export const APP_LOAD = 'APP_LOAD';
export const REDIRECT = 'REDIRECT';
export const HOME_PAGE_LOADED = 'HOME_PAGE_LOADED';
export const HOME_PAGE_UNLOADED = 'HOME_PAGE_UNLOADED';
export const SET_PAGE = 'SET_PAGE';
export const ASYNC_START = 'ASYNC_START';
export const ASYNC_END = 'ASYNC_END';

export const OUTER_BORDERS_LOADED = 'OUTER_BORDERS_LOADED';
export const OUTER_BORDERS_UNLOADED = 'OUTER_BORDERS_UNLOADED';


// WEBPACK FOOTER //
// ./src/constants/actionTypes.js